import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { IntlProvider } from 'react-intl';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Import translations
import messages_en from './translations/en.json';
import messages_th from './translations/th.json';
import messages_vi from './translations/vi.json';
import messages_zh from './translations/zh.json';

import reportWebVitals from './reportWebVitals';

// Type for messages
type Messages = Record<string, Record<string, string>>;

const messages: Messages = {
  en: messages_en,
  th: messages_th,
  vi: messages_vi,
  zh: messages_zh,
};

const locale: keyof typeof messages =
  (localStorage.getItem('locale') as keyof typeof messages) || 'th';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Root element with id 'root' not found");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  //<React.StrictMode>
    <IntlProvider locale={locale} messages={messages[locale]}>
      <App />
    </IntlProvider>
  //</React.StrictMode>
);

reportWebVitals();
